<div [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow} ">
  <div class="pageTitle">
    {{tittle}}
    <i class="material-icons pullfloat-right" (click)="close()">close</i>

  </div>
  <div class="subBlockContent">
    <!-- -->

    <div class="row">

      <div class="card col-md-2" *ngFor="let item of demoArray">
        <img class="card-img-top" src="https://portal.dickerdata.com.au/images/brands/ANKER.jpg " alt="">
        <div class="card-body">
          <h4 class="card-title">Title</h4>
          <p class="card-text">details</p>
        </div>
      </div>
    </div>

  </div>
  <div #entry>


  </div>
</div>
